import axios from 'axios';
import { ElMessageBox, ElLoading } from 'element-plus'


const baseApiURL = import.meta.env.VITE_BASE_URL || '/api'

// 创建 axios 实例
const service = axios.create({
  baseURL: baseApiURL, // 基础 API 地址，可根据环境变量配置
  withCredentials: true
});

// 请求拦截器
let loadingNum = 0
let loading = null
service.interceptors.request.use(
  config => {
    if (!config.ignoreLoading) {
      loadingNum++
      loading = ElLoading.service({
        text: '正在执行操作，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
        body: true,
        lock: false
      })
    }
    return config;
  },
  error => {
    // 处理请求错误
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const config = response.config;
    if (!config.ignoreLoading) {
      loadingNum--
      if (loading && loadingNum <= 0) {
        loadingNum = 0
        loading.close()
      }
    }
    // 处理响应数据
    const res = response.data;
    if (res.code !== 200) {
      // 统一提示业务错误信息
      ElMessageBox.alert(res.message, '提示')
      // 处理业务错误
      console.error('业务错误:', res.message);
      return Promise.reject(new Error(res.message || 'Error'));
    }
    return res;
  },
  error => {
    // 处理响应错误
    console.error('响应错误:', error);
    return Promise.reject(error);
  }
);

export default service;
